import { IAttributeConvert } from "./IAttributeConvert";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { ExportValue } from "./ExportValue";
import { AttributeValue } from "./AttributeValue";
import { AttributeView } from "./AttributeView";
import { Feature } from "ol";

/**
 * 画面サイズ（横幅）
 */
const VALUE_WIDTH = 470;

/**
 * 画面サイズ（縦幅）
 */
const VALUE_HEIGHT = 381;

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "rkil_cmpl_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "rkil_cmpl_yyyyMMdd_HHmmss.csv";

/**
 * ロードキル対策実施状況属性変換クラス
 */
export class RoadkillCountermeasureStatusAttributeConvert
  implements IAttributeConvert
{
  /**
   * 地物
   */
  feature: Feature;

  /**
   * 属性画面タイトル
   */
  title: string;

  constructor(feature: Feature) {
    this.feature = feature;
    this.title = `ロードキル（対策実施状況）`;
  }

  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FeatureType.RoadkillCountermeasure;
  }

  /**
   * 画面用フォーマットに変換
   */
  getViewFormatData(): AttributeView {
    const properties = this.feature.getProperties();
    // 画面項目定義リスト
    const items = [
      {
        key: "No",
        value: properties.No,
        isSimple: true,
      },
      {
        key: "都道府県",
        value: properties.都道府県,
        isSimple: true,
      },
      {
        key: "市区町村",
        value: properties.市区町村,
        isSimple: true,
      },
      {
        key: "道路種別",
        value: properties.道路種別,
        isSimple: true,
      },
      {
        key: "路線番号",
        value: properties.路線番号,
        isSimple: true,
      },
      {
        key: "設置位置（始点）（キロポスト）",
        value: properties["設置位置（始点）（キロポスト）"],
        isSimple: true,
      },
      {
        key: "設置位置（終点）（キロポスト）",
        value: properties["設置位置（終点）（キロポスト）"],
        isSimple: true,
      },
      {
        key: "上下別",
        value: properties.上下別,
        isSimple: true,
      },
      {
        key: "対策分類",
        value: properties.対策分類,
        isSimple: true,
      },
      {
        key: "対策名",
        value: properties.対策名,
        isSimple: true,
      },
      {
        key: "対策年月",
        value:
          properties.対策_年 && properties.対策_月
            ? `${properties.対策_年}/${properties.対策_月}`
            : "-",
        isSimple: true,
      },
      {
        key: "交通調査基本区間番号",
        value: properties.センサス交通調査区間番号,
        isSimple: true,
      },
      {
        key: "道路管理者（地方整備局）",
        value: properties["道路管理者（地方整備局）"],
        isSimple: false,
      },
      {
        key: "道路管理者（事務所等）",
        value: properties["道路管理者（事務所等）"],
        isSimple: false,
      },
      {
        key: "道路管理者（出張所等）",
        value: properties["道路管理者（出張所等）"],
        isSimple: false,
      },
      {
        key: "設置機関（道路管理者と異なる場合）",
        value: properties["設置機関（道路管理者と異なる場合）"],
        isSimple: false,
      },
      {
        key: "設置位置（始点）（経度）",
        value: properties["設置位置（始点）（経度）"],
        isSimple: false,
      },
      {
        key: "設置位置（始点）（緯度）",
        value: properties["設置位置（始点）（緯度）"],
        isSimple: false,
      },
      {
        key: "設置位置（終点）（経度）",
        value: properties["設置位置（終点）（経度）"],
        isSimple: false,
      },
      {
        key: "設置位置（終点）（緯度）",
        value: properties["設置位置（終点）（緯度）"],
        isSimple: false,
      },
    ];
    // 画面項目リストでAttributeValue配列を生成しクラス変数に格納後、return
    const attributeValues: AttributeValue[] = [];
    items.forEach((item) => {
      attributeValues.push(
        new AttributeValue(
          item.key,
          item.value ? item.value.toString() : null,
          item.isSimple
        )
      );
    });
    const attributeView = new AttributeView(
      attributeValues,
      this.title,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      VALUE_HEIGHT,
      null,
      false,
      false
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = this.feature.clone();
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
